import { useState } from 'react';
import { useMediaQuery } from '../../ui/use-media-query.ts';

/** Cómo se muestran las listas de órdenes: tarjetas (la de siempre) o tabla. */
export type OrderView = 'cards' | 'table';

// La tabla solo se ofrece en escritorio (el ancho del menú lateral); en teléfono y tablet siempre van tarjetas.
export const DESKTOP_QUERY = '(min-width: 900px)';

// La vista elegida se recuerda en este dispositivo y la comparten el panel y la ficha del cliente.
const VIEW_KEY = 'miyama:orders-view';

function readView(): OrderView {
  try {
    return localStorage.getItem(VIEW_KEY) === 'table' ? 'table' : 'cards';
  } catch {
    return 'cards';
  }
}

export function useOrderView(): [OrderView, (view: OrderView) => void] {
  const [view, setView] = useState(readView);
  const desktop = useMediaQuery(DESKTOP_QUERY);

  function changeView(next: OrderView) {
    setView(next);
    try {
      localStorage.setItem(VIEW_KEY, next);
    } catch {
      // Sin almacenamiento: la vista cambia igual, solo no se recuerda.
    }
  }

  // Lo elegido se conserva: al volver a una pantalla ancha reaparece la tabla si estaba elegida.
  return [desktop ? view : 'cards', changeView];
}
